import { Radio } from "antd";

function RadioGroup({ filterItemsTypeOptions, handleChange, isUpdate, value }) {
  return (
    <Radio.Group
      options={filterItemsTypeOptions}
      value={value !== undefined ? value : isUpdate ? true : false}
      defaultValue={value === undefined ? (isUpdate ? true : false) : undefined}
      onChange={handleChange}
      style={{
        display: "flex",
        justifyContent: "end",
      }}
      optionType="button"
    />
  );
}

export default RadioGroup;
